var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 7.33398V13.4007C12.6673 13.732 12.3987 14.0007 12.0673 14.0007H3.93398C3.60261 14.0007 3.33398 13.732 3.33398 13.4007V7.33398",
    stroke: "#E64E2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 11.334V7.33398",
    stroke: "#E64E2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 11.334V7.33398",
    stroke: "#E64E2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.66602L10.6667 4.66602M2 4.66602L5.33333 4.66602M5.33333 4.66602V2.59935C5.33333 2.26798 5.60196 1.99935 5.93333 1.99935H10.0667C10.398 1.99935 10.6667 2.26798 10.6667 2.59935V4.66602M5.33333 4.66602L10.6667 4.66602",
    stroke: "#E64E2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.7fc7594f734b00d8e9785622a36bae97.svg";
export { ForwardRef as ReactComponent };